

















































import MaskedInput from 'vue-text-mask';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Label } from '../components';
import { IFormInput, Mask } from './types';

@Component({
  components: {
    Label,
    MaskedInput,
  },
})
export default class FormInput extends Vue implements IFormInput {
  @Prop({ type: String, default: 'name' })
  readonly name!: string;

  @Prop({ type: String, default: 'Ошибка!' })
  readonly errorText!: string;

  @Prop({ type: String, default: '' })
  readonly placeholder!: string;

  @Prop({ type: String, default: 'text' })
  readonly type!: string;

  @Prop({ type: String, default: '' })
  readonly label!: string;

  @Prop({ type: [String, Number], default: '' })
  readonly value!: string | number;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly readonly!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly autofocus!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ type: [String, Array, Boolean], default: '' })
  readonly mask!: Mask;

  @Prop({ type: Boolean, default: false })
  readonly error!: boolean;

  @Prop({ type: [Object, Function, Boolean], default: null })
  readonly v!: object | boolean | any;

  @Prop({ type: String, default: 'input' })
  readonly ariaLabel!: string;

  @Prop({ type: String, default: '30' })
  readonly maxlength!: string;

  @Prop({ type: String, default: '2' })
  readonly minlength!: string;

  @Prop({ type: String, default: 'on' })
  readonly autocomplete!: string;

  @Prop({ type: Boolean, default: false })
  readonly sidebar!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly bigLabel!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly ignoreValidationFirstRenderingByMask!: boolean;

  public isPassVisible: boolean = false;



  get vError(): boolean {
    return this.error || (this.v && this.v.$error);
  }

  get classes(): Array<string> {
    const { vError, readonly, label } = this;
    const result = [];
    if (vError) result.push('input__field_error');
    if (readonly) result.push('input__field_readonly');
    if (!label.length) result.push('input__field_top');
    return result;
  }

  get inputType() {
    const { isPassVisible, type } = this;
    return isPassVisible ? 'text' : type;
  }

  input($event: any): void {
    const value = $event.target ? $event.target.value : $event;
    // можно словить сайд
    if (this.mask ) {
      this.value ? this.touch() : null
    }
    else {
      this.touch()
    }
    this.$emit('input', value);
  }

  blur($event: any): void {
    const value = $event.target ? $event.target.value : $event;
    this.$emit('blur', value);
  }

  touch(): void {
    if (this.v) {
      this.v.$touch();
    }
  }

  togglePass() {
    this.isPassVisible = !this.isPassVisible;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/components/input/Input.vue